module.exports = __webpack_public_path__ + "img/931dda33e81aa84062298a72514b2e19.svg";